export default __webpack_public_path__ + "static/media/email.59347b3a.mp4";